/* eslint-disable no-undef */
import { useEffect, useState } from 'react';
import { BsQuestionCircle } from 'react-icons/bs';

import BayTooltip from '../../BayTooltip';
import { handleChatSupport, isChatSupportReady } from '../../utilities/chatSupport';
import { StyledNavButton } from '../styles/navStyles';

interface SupportButtonProps {
	type?: string;
	platform?: string;
}

const READY_POLL_MS = 500;

// The Zoho ASAP script is deferred and fetched from a remote host, so its widget
// is not in the DOM when the nav first renders. Keep the button disabled until
// it is, rather than letting an early click silently do nothing.
const useChatSupportReady = () => {
	const [ready, setReady] = useState(isChatSupportReady);

	useEffect(() => {
		if (ready) {
			return undefined;
		}

		const intervalId = setInterval(() => {
			if (isChatSupportReady()) {
				setReady(true);
			}
		}, READY_POLL_MS);

		return () => clearInterval(intervalId);
	}, [ready]);

	return ready;
};

const SupportButton = ({ type }: SupportButtonProps) => {
	const ready = useChatSupportReady();

	return type === 'chat' && (
		<BayTooltip
			overlay={
				<span id="tooltip-zoho-chat-icon">Help Center</span>
			}
			placement="bottom"
		>
			<StyledNavButton
				className={`desktop-menu-icons${ready ? '' : ' disabled opacity-50'}`}
				id="zoho-chat-icon"
				role="button"
				disabled={!ready}
				onClick={() => handleChatSupport()}
			>
				<BsQuestionCircle size={16} />
			</StyledNavButton>
		</BayTooltip>
	) ;
};

export default SupportButton;
